import { createCollectionReducer } from 'ext/lib/collections';

const TYPE = 'experiences-summary';

export default createCollectionReducer(TYPE);

export const selectExperiencesSummary = state => state[TYPE];
export const selectExperience = (state, id) => state[TYPE][id];
